import attachFilesUtil from '@src/components/ChatMessageComposer/ComposerToolbar/FileUtils';
import useAttachFilesSummary from '@src/hooks/useAttachFilesSummary';
import { supportsMultipleFileTypes } from '@src/model/frontendmodel';
import { activeChatSelector } from '@src/selectors/chats';
import mediaUtils, {
  commonImageExtensionsAllowed,
  commonVideoExtensionsAllowed,
} from '@src/utils/mediaUtils';
import React, { ChangeEvent, RefObject } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

interface IFormInputs {
  uploadFilesFormRef: RefObject<HTMLFormElement>;
  imageFileInputRef: RefObject<HTMLInputElement>;
  documentFileInputRef: RefObject<HTMLInputElement>;
}

const FormInputs: React.FC<IFormInputs> = ({
  uploadFilesFormRef,
  imageFileInputRef,
  documentFileInputRef,
}) => {
  const { formatMessage } = useIntl();

  const { isAttachFilesSummaryEnabled } = useAttachFilesSummary();

  const activeChat = useSelector(activeChatSelector);

  let fileAccepted = mediaUtils.FILE_ACCEPTED_PDF;

  if (activeChat?.provider && supportsMultipleFileTypes(activeChat?.provider)) {
    fileAccepted = mediaUtils.FILE_ACCEPTED_ALL;
  }

  const handleSend = (event: ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target?.files || []);
    attachFilesUtil({
      files,
      activeChat,
      formatMessage,
      isAttachFilesSummaryEnabled,
    });
    uploadFilesFormRef.current?.reset();
  };

  return (
    <form style={{ display: 'none' }} ref={uploadFilesFormRef}>
      <input
        type="file"
        id="inImageUpload"
        name="imageUpload"
        style={{ display: 'none' }}
        onChange={handleSend}
        ref={imageFileInputRef}
        accept={[
          ...commonImageExtensionsAllowed,
          ...commonVideoExtensionsAllowed,
        ].join(',')}
        multiple
      />

      <input
        type="file"
        id="inDocumentUpload"
        name="documentUpload"
        style={{ display: 'none' }}
        onChange={handleSend}
        ref={documentFileInputRef}
        accept={fileAccepted}
        multiple
      />
    </form>
  );
};

export default FormInputs;
